import { Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog'
import { Subject, takeUntil } from 'rxjs'
import { escapeKey$ } from '../../services'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'app-duplicate-ils-dialog',
  imports: [TranslatePipe, MatButton, MatDialogActions, MatDialogContent, MatDialogTitle],
  templateUrl: './duplicate-ils-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './duplicate-ils-dialog.component.scss',
})
export class DuplicateIlsDialogComponent implements OnInit, OnDestroy {
  private dialogRef = inject<MatDialogRef<DuplicateIlsDialogComponent>>(MatDialogRef)

  private readonly unsubscribe$ = new Subject<void>()

  constructor() {
    escapeKey$(this.dialogRef).subscribe(() => this.dialogRef.close())
  }

  ngOnInit(): void {
    this.dialogRef
      .keydownEvents()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((event) => {
        console.log('keydownEvents', event.key)
        if (event.key === 'Enter') {
          this.duplicate()
          event.preventDefault()
        }
      })
  }

  cancel() {
    this.dialogRef.close(false)
  }

  duplicate() {
    this.dialogRef.close(true)
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next()
  }
}
